module.exports = __webpack_public_path__ + "img/favorites.85732fc2.jpg";